import React from 'react';
import ForgotPassword from '../components/auth/forgotpassword/ForgotPassword';

const ForgotPasswordPage = () => {
    return <ForgotPassword />;
};

export default ForgotPasswordPage;
